// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body.using-keyboard .heading[data-v-3b552a32]:focus{box-shadow:0 0 0 0}body.using-keyboard .heading:focus .checkbox-container[data-v-3b552a32]{border-radius:0;box-shadow:0 0 0 2px #000}", ""]);
// Exports
module.exports = exports;
